import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LeafCollectionRouteSummaryReport } from './Pages';

export const LeafCollectionRouteSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={LeafCollectionRouteSummaryReport} />
    </Fragment>
)